/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Quotes from '@/views/Quotes'
import Queries from '@/views/Queries'

import store from '@/store.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'Quotes',
      component: Quotes,
      meta: {
        title: 'Quotes',
        requiresAuth: true
      }
    },
    {
      path: '/queries',
      name: 'Queries',
      component: Queries,
      meta: {
        title: 'Queries',
        requiresAuth: true
      }
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    Vue.$toast.error('Please login first!')
    next('/login')
  } else if (to.matched.some(record => record.meta.requiresAuth === false)) {
    if (store.getters.isLoggedIn) {
      next('/')
      return
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js